import { BehaviorSubject } from 'rxjs';

class TabContainer {
    constructor() {
        this._subject = new BehaviorSubject(null);
        this.observable = this._subject.asObservable();
        this.setActiveTab = (tabTitle) => this._subject.next(tabTitle);
    }
}

class TabService {
    tabContainers = {};

    createTabContainer(containerId) {
        if (!this.tabContainers[containerId]) {
            this.tabContainers[containerId] = new TabContainer();
        }
    }

    getTabContainer(containerId) {
        return this.tabContainers[containerId];
    }

    getContainerObservable(containerId) {
        if (!this.tabContainers[containerId]) {
            this.createTabContainer(containerId);
        }

        return this.tabContainers[containerId]?.observable;
    }
}

const tabService = new TabService();

window.tabContainers = tabService.tabContainers;

export default tabService;
